var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bar"},_vm._l((_vm.availableSlotSizes),function(availableSlotSize,index){return _c('button',{key:index,class:[
      'bar-item',
      'button',
      { orange: _vm.selectedButton && _vm.selectedButton.size === availableSlotSize.size } ],on:{"click":function($event){return _vm.selectButton(availableSlotSize)}}},[_vm._v(" "+_vm._s(availableSlotSize.nameGreek)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }